import { Component, OnInit } from '@angular/core';
import { GenericService } from '../services/generic.service';
import { SplashScreenStateService } from '../services/splash-screen-state-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public currentCount = 0;
  public item1 = '';
  public item2 = '';
  public theHtmlString ="";
  public theHtmlString2 ="";
  retItem: any;
  constructor(private genericService: GenericService ) //, private splashScreenStateService: SplashScreenStateService) 
  { 


  }


  ngOnInit(): void {
    // setTimeout(() => {
    //    this.splashScreenStateService.stop();
       
    // }, 500);
    this.LoadData();
 }



/*   ngOnInit() {

this.LoadData();

  } */

  LoadData() {
    
        this.genericService.getItem(227).subscribe((data) => {
          this.retItem = data;
          console.log(this.retItem);
       //   if (this.retItem.length > 0) {
           this.currentCount = this.retItem.length;
            this.item1 = this.retItem.name;
            this.item2 = this.retItem.name_sub;
            this.theHtmlString = this.retItem.html_content;
            this.theHtmlString2 = this.retItem.html_content2;
        //    this.splashScreenStateService.stop();
          //  alert("data here");
          //   this.dataavailbale = true;
          // }
          // else {
          //   this.dataavailbale = false;
       //   }
    
    
        }
        )
          , err => {
            console.log(err);
          }
      }

}
